// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__3IiYL","title":"ClientInsurance_title__2r0yF","itemText":"ClientInsurance_itemText__1q98a"};